import React, { useEffect, useState } from 'react';

import {
  Carousel,
  type CarouselApi,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel';
import { cn } from '@/utils';

export const ProductRecommendationsTabs = ({
  status,
  categories,
  selectedCategoryIndex,
  onSelect,
}: {
  status: 'error' | 'success' | 'pending';
  categories: string[];
  selectedCategoryIndex: number;
  onSelect: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const [api, setApi] = useState<CarouselApi>();
  useEffect(() => {
    if (api) {
      api.on('select', () => {
        const selectedIndex = api.selectedScrollSnap();
        onSelect(selectedIndex);
      });
    }
  }, [api, categories, onSelect]);

  if (status === 'error') {
    return null;
  }

  if (status === 'pending') {
    return (
      <div className="flex gap-4 border-b border-b-black-100 pb-2 pl-4 md:gap-8 md:pl-8">
        {categories.map((category) => (
          <div
            key={category}
            className={cn(
              'min-w-0 shrink-0 grow-0 basis-auto',
              'text-[clamp(1.25rem,3vw,2.75rem)] font-bold text-black-300 transition-colors hover:cursor-pointer',
            )}
          >
            {category}
          </div>
        ))}
      </div>
    );
  }

  return (
    <Carousel
      className="border-b border-b-black-100 pb-2"
      showMobileDots={false}
      setApi={setApi}
      opts={{
        loop: true,
        containScroll: false,
        align: (viewSize: number) => {
          const paddingInPixels = viewSize > 768 ? 32 : 16;
          return paddingInPixels;
        },
      }}
    >
      <CarouselContent>
        {categories.map((category, index) => (
          <CarouselItem
            key={category}
            className={cn(
              'basis-auto',
              'text-[clamp(1.25rem,3vw,2.75rem)] font-bold transition-colors hover:cursor-pointer',
              {
                'text-black': selectedCategoryIndex === index,
                'text-black-300': selectedCategoryIndex !== index,
              },
            )}
            onClick={() => {
              api?.scrollTo(index);
              onSelect(index);
            }}
          >
            {category}
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
};
